import { QueryConfig } from "store/utils/query-config";

export const connectionDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.createdAt"]
  }
};
